import * as React from 'react';

import { ProjectGeoDataByIri } from 'src/constants/projectGeoData';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { setGeoDataForIri } from 'src/containers/ProjectDiagram/utils/geoData';

export const useUpdateGeoData = (classIri?: string) => {
  const diagram = useDiagram();

  return React.useCallback(
    (geoData: ProjectGeoDataByIri) => {
      if (!diagram || !classIri) {
        return;
      }

      commitDiagramModel(diagram, setGeoDataForIri(classIri, geoData));
    },
    [classIri, diagram]
  );
};
